import { useEffect, useRef, useState } from "react";
import searchIcon from "../../assets/Icons/search_icon.svg";
import partEntryIcon from "../../assets/Icons/part_entries_icon.svg";
import batchesIcon from "../../assets/Icons/batches_icon.svg";
import unitsConvertsIcon from "../../assets/Icons/units_converts_icon.svg";
import consumibleExpandibleIcon from "../../assets/Icons/consumible_expandible_icon.svg";
import physicalInventoryIcon from "../../assets/Icons/physical_inventory_icon.svg";
import iconViewMore from "../../assets/Icons/view_more_icon.svg";
import fileIcon from "../../assets/Icons/file_icon.svg";
import transactionIcon from "../../assets/Icons/transaction_icon.svg";

import "./GlobalSearchBar.scss";
import useDebounce from "../../hooks/useDebounce";
import { Tooltip } from "@mui/material";
import { get, set } from "react-hook-form";
import {
  getGlobalSearchFiles,
  getGlobalSearchResults,
  getRecentNavigation,
  getRecentSearch,
  saveRecentSearch,
} from "../../services/authService";
import { iconsMapSvg, tabMap } from "../Wrapper/Wrapper";
import { useDispatch } from "react-redux";
import {
  addTab,
  clearActiveTab,
  setActiveTab,
} from "../../redux/features/TabsManager/tabSlice";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";

const testResponse = [
  {
    id: 32,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "JM Part",
  },
  {
    id: 33,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 09",
  },
  {
    id: 34,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "AAPart 5345edr",
  },
  {
    id: 36,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "ABC Part",
  },
  {
    id: 45,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "NAME FOR PART AA 333DSFLKJSÑDFK",
  },
  {
    id: 66,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "AA22 Part 1234",
  },
  {
    id: 82,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "AA-3050 Part",
  },
  {
    id: 83,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "AA-000000000 part",
  },
  {
    id: 89,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Xyz wabcd Part Name",
  },
  {
    id: 91,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "QRS-12345 Part",
  },
  {
    id: 103,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 56F144",
  },
  {
    id: 137,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 56F1443",
  },
  {
    id: 155,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part A",
  },
  {
    id: 156,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part B test 1",
  },
  {
    id: 157,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "PART A TEST 2 EDITED",
  },
  {
    id: 158,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part B test 2",
  },
  {
    id: 159,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part C Test 2",
  },
  {
    id: 160,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part D Test 2",
  },
  {
    id: 161,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part  E Test2",
  },
  {
    id: 162,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part A test 4",
  },
  {
    id: 163,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part B test 4",
  },
  {
    id: 164,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part C Test 4",
  },
  {
    id: 165,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part A Test 4 v 2",
  },
  {
    id: 166,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part B Test 4 v 2",
  },
  {
    id: 167,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part  C Test 4 v2",
  },
  {
    id: 233,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part -233",
  },
  {
    id: 234,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 234",
  },
  {
    id: 235,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 235",
  },
  {
    id: 236,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 236",
  },
  {
    id: 237,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 237",
  },
  {
    id: 238,
    table: "parts",
    matchingField: "name",
    screenPath: "/configuration/parts",
    screenName: "Parts",
    matchingValue: "Part 238",
  },
];
export const GlobalSearchBar = ({
  searchActions,
  isLocalSearch,
  searchInputProps,
}) => {
  const [isSearching, setIsSearching] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [globalInputValue, setGlobalInputValue] = useState("");
  const [localizedSearch, setLocalizedSearch] = useState(isLocalSearch);
  const [finalEmitSearch, setFinalEmitSearch] = useState("");
  const debValue = useDebounce(inputValue, 300);

  const containerRef = useRef(null); // 📌 1. Referencia del contenedor

  useEffect(() => {
    searchInputProps?.onTextChange?.(debValue);
  }, [debValue]);

  const showResultCont = () => setIsSearching(true);
  const hideResultCont = () => setIsSearching(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        hideResultCont();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setFinalEmitSearch(globalInputValue);
    }, 500); // 500ms delay

    return () => {
      clearTimeout(handler);
    };
  }, [globalInputValue]);

  return (
    <section className="globalsearchbar-component" ref={containerRef}>
      <section className="search-inp-cont bg-white-100">
        <div className="global-search-cont bg-white-100">
          {localizedSearch ? (
            <input
              type="text"
              placeholder="Search within this module..."
              autoComplete="off"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              {...searchInputProps}
            />
          ) : (
            <input
              type="text"
              placeholder="Search across the entire system..."
              onFocus={showResultCont}
              value={globalInputValue}
              onChange={(e) => setGlobalInputValue(e.target.value)}
            />
          )}
          {inputValue && (
            <i
              className="icon-light-cross clear-search"
              onClick={() => setInputValue("")}
            ></i>
          )}
          <Tooltip
            title={
              localizedSearch
                ? "Switch to global Search"
                : "Switch to module search"
            }
          >
            <i
              className={`${
                localizedSearch ? "icon-search" : "icon-globe-search"
              } searchicon`}
              onClick={() => setLocalizedSearch((prev) => !prev)}
            ></i>
          </Tooltip>
        </div>
        {!localizedSearch && (
          <SearchResults
            isSearching={isSearching}
            setIsSearching={setIsSearching}
            finalEmitSearch={finalEmitSearch}
          />
        )}
      </section>
      {searchActions && <div className="search-actions">{searchActions}</div>}
    </section>
  );
};

const SearchResults = ({ isSearching, setIsSearching, finalEmitSearch }) => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(4);
  const [totalPage, setTotalPage] = useState(0);
  const [totalRecentList, setTotalRecentList] = useState([]);
  const [recentList, setRecentList] = useState([]);
  const [recentsExpanded, setRecentsExpanded] = useState(true);
  const [transactionsExpanded, setTransactionsExpanded] = useState(false);
  const [labelSearch, setLabelSearch] = useState("Recent Searches");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  ///
  const [transactionsResults, setTransactionsResults] = useState([]);

  const [isLoadingTransactions, setIsLoadingTransactions] = useState(false);
  ///
  const [fileResults, setFileResults] = useState([]);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  useEffect(() => {
    if (!finalEmitSearch) {
      setTransactionsResults([]);
      setIsLoadingTransactions(false);
      setFileResults([]);
      setIsLoadingFiles(false);
      setRecentList(totalRecentList);
      setRecentsExpanded(true);
      getRecentSearch().then((response) => {
        setLabelSearch("Recent Searches");
        const recentSearches = response.data.load.map((item) => ({
          id: item.itemId,
          ...item,
        }));
        setFileResults(recentSearches);
      });
      return;
    }
    setIsLoadingTransactions(true);
    setRecentsExpanded(false);
    setRecentList(totalRecentList.slice(0, 4));
    getGlobalSearchResults(finalEmitSearch)
      .then((response) => {
        const transactions = response.data.load.items.map((transaction) => ({
          ...transaction,
          icon: transaction.isModule
            ? iconsMapSvg[transaction.icon]
            : transaction.icon,
        }));
        setTransactionsResults(transactions);

        setIsLoadingTransactions(false);
      })
      .catch((error) => {
        console.error("Error fetching global search results:", error);
        setIsLoadingTransactions(false);
      });

    //
    setIsLoadingFiles(true);
    // setTimeout(() => {
    //   setFileResults(testResponse);
    //   setIsLoadingFiles(false);
    // }, 3000);
    getGlobalSearchFiles(finalEmitSearch)
      .then((response) => {
        setLabelSearch("Files");
        const files = response.data.load;

        const categories = Object.values(
          files.reduce((acc, file) => {
            if (!acc[file.screenName]) {
              acc[file.screenName] = {
                name: file.screenName,
                files: [],
              };
            }
            acc[file.screenName].files.push(file);
            return acc;
          }, {})
        );

        console.log("Categories:", categories);

        setFileResults(categories);
        setIsLoadingFiles(false);
      })
      .catch((error) => {
        setIsLoadingTransactions(false);
      })
      .catch((error) => {
        console.error("Error fetching global search results:", error);
        setIsLoadingTransactions(false);
      });

    //   localStorage.setItem("lastSearch", finalEmitSearch);
  }, [finalEmitSearch]);

  // Función para paginar

  useEffect(() => {
    if (isSearching) {
      setPage(0);
      getRecentNavigation(0, 9999).then((response) => {
        const finalList = response.data.load.map((item) => {
          if (item.module != null) {
            return {
              ...item.module,
              icon: iconsMapSvg[item.module.icon],
              isModule: true,
            };
          } else {
            return {
              ...item.resource,
              isModule: false,
            };
          }
        });
        setTotalRecentList(finalList);
        if (!recentsExpanded) {
          setRecentList(finalList.slice(0, 4));
        } else {
          setRecentList(finalList);
        }
        setTotalPage(response.data.totalPages);
      });
      getRecentSearch().then((response) => {
        const recentSearches = response.data.load.map((item) => ({
          ...item,
          id: item.itemId,
          table: item.tableName,
        }));
        setFileResults(recentSearches);
      });
    }
  }, [isSearching]);

  const handleRedirectFile = (item) => {
    const itemToSave = {
      itemId: item.id,
      tableName: item.table,
      matchingField: item.matchingField,
      matchingValue: item.matchingValue,
      screenName: item.screenName,
      screenPath: item.screenPath,
    };
    saveRecentSearch(itemToSave);
    dispatch(clearActiveTab());
    navigate("/secure" + item.screenPath, {
      state: { dataFromManualSearch: item.id },
    });
    setIsSearching(false);
  };
  const handleRedirect = (item) => {
    if (item.isModule) {
      const moduleToAdd = {
        id: item.id,
        title: item.name,
        color: item.color,
        icon: item.icon,
        path: item.url,
        isPinned: false,
        componentKey: item.name,
        date: generateUUID(),
        isModule: true,
      };

      dispatch(addTab(moduleToAdd));
    } else {
      window.history.pushState(null, "", item.url);
      const match = tabMap[item.url];
      if (!match) {
        return;
      }
      dispatch(
        addTab({
          icon: item.icon,
          color: item.color,
          path: item.url,
          id: item.id,
          title: item.name,
          isPinned: false,
          componentKey: match.componentKey,
          isModule: false,
          date: generateUUID(),
        })
      );
      dispatch(setActiveTab(item.url));
    }
    setIsSearching(false);
  };

  function generateUUID() {
    return crypto.randomUUID();
  }

  const expandRecents = () => {
    const newExpandedValue = !recentsExpanded;
    setRecentsExpanded(newExpandedValue);
    if (newExpandedValue) {
      setRecentList(totalRecentList);
    } else {
      setRecentList(totalRecentList.slice(0, 4));
    }
  };

  return (
    <section
      className={`navbar-search-results-cont bg-white ${
        isSearching ? "visible" : ""
      }`}
      id="results-cont"
    >
      <section className="all-results">
        <div
          className={`all-results-left ${
            recentsExpanded || transactionsExpanded ? "expanded" : ""
          }`}
        >
          <div
            className={`recent-searchs ${recentsExpanded ? "expanded" : ""} ${
              transactionsExpanded ? "hidden" : ""
            }`}
          >
            <div className="recent-search-header">
              <div className="recent-search-header-title">
                <i className="icon-recents"></i>
                <b className="txt-black-mid">Recents</b>
              </div>
            </div>
            <section>
              <div className="list-of-recents ">
                {recentList.map((item, index) => (
                  <span key={index} onClick={() => handleRedirect(item)}>
                    <span
                      className="span-recent-module"
                      style={{ backgroundColor: item.color }}
                    >
                      <i className={item.icon}></i>
                    </span>
                    <p className="txt-black-mid">{item.name}</p>
                  </span>
                ))}
              </div>
            </section>
            <div className="recent-search-expand-container">
              <div
                className={`recent-search-expand-container-arrow ${
                  recentsExpanded ? "expanded" : ""
                }`}
                onClick={() => expandRecents()}
              >
                <i className="icon-arrow-down"></i>
              </div>
            </div>
          </div>
          {!recentsExpanded && (
            <div
              className={`transactions-results ${
                transactionsExpanded ? "expanded" : ""
              }`}
            >
              <div className="recent-search-header">
                <div className="recent-search-header-title">
                  <i className="icon-transactions"></i>
                  <b className="txt-black-mid"> Transactions</b>
                </div>
              </div>

              <section className="list-transactions">
                {isLoadingTransactions ? (
                  <>
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                    <Skeleton height={"100%"} />
                  </>
                ) : transactionsResults.length === 0 ? (
                  <p className="txt-grey--200">No transactions found</p>
                ) : (
                  transactionsResults.map((transaction, index) => (
                    <span
                      key={index}
                      className="bg-white"
                      style={{ padding: "0.5rem" }}
                      onClick={() => handleRedirect(transaction)}
                    >
                      <i className={transaction.icon} />
                      <p className="txt-black-mid">{transaction.name}</p>
                    </span>
                  ))
                )}
              </section>
              <div className="recent-search-expand-container">
                <div
                  className={`recent-search-expand-container-arrow ${
                    transactionsExpanded ? "expanded" : ""
                  }`}
                  onClick={() => setTransactionsExpanded(!transactionsExpanded)}
                >
                  <i className="icon-arrow-down"></i>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="all-results-right">
          <div className="files-results ">
            <div className="recent-search-header">
              <div className="recent-search-header-title">
                <i className="icon-file-icon"></i>
                <b className="txt-black-mid">{labelSearch}</b>
              </div>
            </div>

            <section className={`list-files ${labelSearch == "Files" ? "view-list" : ""}`}>
              {isLoadingFiles ? (
                <>
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                  <Skeleton height={"100%"} />
                </>
              ) : fileResults.length === 0 ? (
                <p className="txt-grey--200">No files found</p>
              ) : labelSearch == "Files" ? (
                fileResults.map((file, index) => {
                  return (
                    <div key={index} className="category-file-container">
                      <div className="category-title-file"><b>{file.name}</b></div>
                      {file.files.map((fileItem, fileIndex) => {
                        const regex = new RegExp(`(${finalEmitSearch})`, "ig");
                        const highlightedValue = fileItem.matchingValue.replace(
                          regex,
                          "<strong>$1</strong>"
                        );
                        return (
                          <span
                            key={fileIndex}
                            className="bg-white"
                            style={{ padding: "0.5rem" }}
                            onClick={() => handleRedirectFile(fileItem)}
                          >
                            <i className="icon-file-icon"></i>
                            <div className="text-file-container">
                              <span
                                className="txt-black-mid"
                                dangerouslySetInnerHTML={{
                                  __html: highlightedValue,
                                }}
                              />
                              <p>{fileItem.matchingField}</p>
                            </div>
                          </span>
                        );
                      })}
                    </div>
                  );
                })
              ) : (
                fileResults.map((file, index) => {
                  const regex = new RegExp(`(${finalEmitSearch})`, "ig");
                  const highlightedValue = file.matchingValue.replace(
                    regex,
                    "<strong>$1</strong>"
                  );

                  return (
                    
                    <span
                      key={index}
                      className="bg-white"
                      style={{ padding: "0.5rem" }}
                      onClick={() => handleRedirectFile(file)}
                    >
                      <i className="icon-file-icon"></i>
                      <div className="text-file-container">
                        <span
                          className="txt-black-mid"
                          dangerouslySetInnerHTML={{ __html: highlightedValue }}
                        />
                        <p>
                          {file.screenName} - {file.matchingField}
                        </p>
                      </div>
                    </span>
                  );
                })
              )}
            </section>
          </div>
        </div>
      </section>
    </section>
  );
};
